import {
  SOCIAL_SHARE_URLS,
  SPECIAL_SOCIAL_SHARE_HANDLERS,
} from '../constants/shared/modals/share-modal';

export const handleShareViaSocial = ({
  platform,
  shareableLink,
}: {
  platform: string;
  shareableLink: string;
}) => {
  if (SOCIAL_SHARE_URLS[platform]) {
    const getUrl = SOCIAL_SHARE_URLS[platform];
    window.open(getUrl(shareableLink), '_blank');
  } else if (SPECIAL_SOCIAL_SHARE_HANDLERS[platform]) {
    const getUrl = SPECIAL_SOCIAL_SHARE_HANDLERS[platform];
    getUrl();
  }
};
